
import {of as observableOf,  Observable, Subscription } from 'rxjs';
import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit, Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, NgForm, Validators } from '@angular/forms';
import { CommonStrainsService } from './common-strains.service';
import { AuthService } from '../../../../core/auth.service';
import { BaseService } from '../../../../shared/base.service';
import { ClinicsService } from '../../../../clinics/clinics.service';
import { BaseComponent } from '../../../../shared/base.component';
import { AppService } from '../../../../app.service';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from '../../../../users/users.service';
import { HomeService } from '../../../../home/home.service';
import { MaintenanceService } from '../../../../maintenance/maintenance.service';
import { SecureApi } from '../../../../core/secure.api';
import {CoreService} from "../../../../core/core.service";
import * as moment from 'moment';
import { InsurancePartnerComponent } from '../../insurance-partner.component';

@Component({
    selector: 'common-strains-component',
    templateUrl: './common-strains.component.html',
    styleUrls: ['./common-strains.component.scss'],
    providers: [CommonStrainsService, ClinicsService, BaseService]
})

export class CommonStrainsComponent extends InsurancePartnerComponent implements OnInit, AfterViewInit, OnDestroy {
    helpClinicProfile: any;
    @Input() isHome = false;
    @Input() filters;
    @Input() filterParams;
    @Input() url = '/admin/mental';

    @Output() setParams = new EventEmitter();

    roles: Object[] = [];
    clinicUsers: Object[] = [];
    clinicId: any = '';
    isFocusMobileInput: boolean = false;
    userRoleId: number;
    isEditable: boolean = false;
    subAdminRight: Subscription;
    clinic: Object = null;
    clinicName: string;
    data: any;
    message: string;
    filterAge: any;
    readonly ageRange = [
        ['All', 0, 999],
        ['18-25', 18, 25],
        ['26-35', 26, 35],
        ['36-45', 36, 45],
        ['46-55', 46, 55],
        ['56-65', 56, 65],
        ['66-75', 66, 75],
        ['76+', 76, 999],
    ];
    readonly genders = [
        {
            name: 'All genders',
            value: 0
        },
        {
            name: 'Female',
            value: 2
        },
        {
            name: 'Male',
            value: 1
        },
        {
            name: 'Gender X',
            value: 3
        }
    ];
    activeLanguage = this.appService.activeLanguage.locale;
    subscription: Subscription;
    filterGender: any;

    @ViewChild('formDirective') private formDirective: NgForm;

    constructor(public authService: AuthService,
                public coreService: CoreService,
                public router: Router,
                public translate: TranslateService,
                public fb: FormBuilder,
                public baseService: BaseService,
                public appService: AppService,
                public usersService: UsersService,
                public homeService: HomeService,
                public clinicService: ClinicsService,
                public secureApi: SecureApi,
                public route: ActivatedRoute,
                public service: CommonStrainsService) {
        super(authService, router, translate, baseService, appService, usersService, homeService);
    }

    ngOnInit() {
        this.url = 'b2c-patients/mental';
        this.userRoleId = this.authService.user['role_id'];
        this.filterGender = this.genders[0];
        this.filterAge = this.ageRange[0];

        this.subscription = this.translate.onLangChange.subscribe((event: any) => {
            this.activeLanguage = event.lang;
        });
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    /**
     * @param {SimpleChanges} changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes['filters'] && this.filters) {
            return this.getItems();
        }
    }

    get isClinicView() {
        return this.clinicId;
    }

    get isAdminView() {
        return (this.clinicName == null && this.clinicCity == null);
    }

    getItems() {
        this.data = null;
        this.message = 'Fetching data...';
        this.service.getAll(this.filters).subscribe(response => {
            this.isLoading = false;
            this.message = response['message'] || '';
            return this.setData(response['data']);
        });
    }

    setData(data: any): void {
        this.data = data && data.length ? data : null;
    }

    setFilterAge(){
        let params = [{
            key: 'startAge',
            value: this.filterAge[1] || 0
        }, {
            key: 'endAge',
            value: this.filterAge[2] || 0
        }
        ];
        return this.setParams.emit(params);
    }

    setFilterGender($event){

        // Set gender
        let gender = 0;
        if ($event && $event.target) {
            // Set gender for input
            gender = $event.target.value;
        } else {
            // Set gender for select
            gender = $event.value;
            this.filterGender = $event;
        }

        let params = [{
            key :  'gender',
            value: gender
        }];
        return this.setParams.emit(params);
    }

    navigateRoute() {
        this.router.navigate(['./'], {
            relativeTo: this.route
        });
    }

    sortUsers(column) {
        if (column === 'created_at') {
            column = 'created_at_sort';
        }

        this.sort(column, false);
    }

    isB2CAdminRole(){
        return this.roleId === this.authService.ROLES.B2C_ADMIN;
    }

    activate(item){
    }

    getPercentage(data){
        return 100 - parseFloat(data['low']) - parseFloat(data['medium']);
    }
}
